export const breakpoints = {
  galaxyFold: '349px',
  iphoneSE: '667px',
};
